import type { FC, PropsWithChildren } from 'react';
import { MdxProvider } from '@anywayseo/tools';

const SiteWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <MdxProvider>{children}</MdxProvider>;
};

export default SiteWrapper;
